import React from 'react';

const Ellipsis = ({children}) => {
    return ( 
        <td style={{ minWidth: 90, maxWidth: 130, overflow: "hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} title={children}>{children}</td>
     );
}
 
export default Ellipsis;
